import { type ReactNode } from 'react'
import { useTheme } from 'styled-components'

import { ListingsCarousel } from '@/components/shared/listings-carousel/ListingsCarousel'
import { Flex } from '@/ui/atoms/flex'
import { HeadlineText } from '@/ui/atoms/headline-text'
import { type ResponsiveProp } from '@/ui/typings/helpers'

type BRPCarouselLayoutProps = {
  title: string
  carouselName: string
  slides: ReactNode[]
  slidesToShow?: ResponsiveProp<number>
  shouldShowArrows?: ResponsiveProp<boolean>
}

export const BRPCarouselLayout = ({
  title,
  carouselName,
  slides,
  slidesToShow = { small: 3, medium: 6, large: 8 },
  shouldShowArrows = { small: false, medium: false, large: true },
}: BRPCarouselLayoutProps) => {
  const { spacing } = useTheme()

  return (
    <Flex flexDirection="column" gap={spacing.default}>
      <HeadlineText as="h2" size="xLarge">
        {title}
      </HeadlineText>
      <ListingsCarousel
        enableImpressionsTracking
        name={carouselName}
        slides={slides}
        slidesToShow={slidesToShow}
        shouldShowArrows={shouldShowArrows}
      />
    </Flex>
  )
}
